import { Separator } from "@/app/components/ui/separator.jsx";

export const FooterSection = () => {
	const footerLinks = [
		{ text: "Terms & Conditions", href: "#" },
		{ text: "Privacy Policy", href: "#" },
	];

	return (
		<footer className="flex flex-col max-w-7xl mx-auto items-start justify-center pb-16 w-full bg-white opacity-0 -translate-y-4 animate-fade-in [--animation-delay:0ms]">
			<div className="flex items-center px-20 py-12 w-full bg-gray-950 rounded-[32px]">
				<div className="flex flex-col items-start gap-16 flex-1">
					<div className="flex items-start gap-[150px] w-full">
						<div className="inline-flex flex-col items-start gap-[21px]">
							<div className="inline-flex flex-col items-start gap-6">
								<div className="inline-flex flex-col items-start gap-2">
									<h2 className="flex items-end justify-center w-fit -mt-px font-['Inter',Helvetica] font-semibold text-white text-xl tracking-normal leading-[30px] whitespace-nowrap">
										CareerfyHQ is part of the Dproz ecosystem.
									</h2>

									<p className="flex items-end justify-center w-fit font-['Inter',Helvetica] font-normal text-gray-400 text-base tracking-normal leading-6 whitespace-nowrap">
										Tunajenga mifumo inayodumu — hatua moja baada ya nyingine.
									</p>
								</div>
							</div>
						</div>
					</div>

					<div className="flex flex-col items-start gap-[9px] w-full">
						<Separator className="w-full h-px -mt-px bg-gray-700" />

						<div className="flex items-center justify-between w-full">
							<p className="flex items-end justify-center w-fit -mt-px font-['Inter',Helvetica] font-normal text-gray-500 text-sm tracking-normal leading-7 whitespace-nowrap">
								©{new Date().getFullYear()} TE-VENTURES INC LTD. All Rights Reserved.
							</p>

							<nav className="inline-flex items-center gap-[37px]">
								{footerLinks.map((link, index) => (
									<a
										key={index}
										href={link.href}
										className="flex items-end justify-center w-fit -mt-px font-['Inter',Helvetica] font-normal text-gray-500 text-sm tracking-normal leading-7 whitespace-nowrap transition-colors hover:text-white"
									>
										{link.text}
									</a>
								))}
							</nav>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};
